<footer class="footer">
    <div class="generic-container footer-container">
        <div class="footer-content">
            <div class="footer-left">
                <div class="logo-container">
                    <img
                        src="https://funfigz-assets-public.s3.ap-south-1.amazonaws.com/product-logo.png"
                        alt="FunFigz Logo"
                        class="logo-image"
                    />
                </div>
                <span class="copyright">
                    <mat-icon
                        aria-hidden="false"
                        aria-label="copyright icon"
                        fontIcon="copyright"
                        class="copyright-icon"
                    ></mat-icon>
                    {{ currentYear }} FunFigz. All rights reserved.
                </span>
            </div>

            <nav class="footer-nav" *ngIf="!isAdminRoute">
                <a href="/contact">Contact Us</a>
                <a href="/terms-and-conditions">Terms & Conditions</a>
                <a href="/privacy-policy">Privacy & Policy</a>
            </nav>

            <div class="footer-right">
                <span class="made-with"
                    >Made with
                    <span class="ping-wrapper">
                        <mat-icon
                            aria-hidden="false"
                            aria-label="love icon"
                            fontIcon="favorite"
                            class="love-icon"
                        ></mat-icon>
                        <mat-icon class="love-ping animate-ping">favorite</mat-icon>
                    </span>
                    for creative minds
                </span>
            </div>
        </div>
    </div>
</footer>
